import React, { Suspense, lazy } from 'react'
import { Route } from 'react-router-dom'

const PitchDeckRenderContainer = lazy(() => import('../modules/PitchDeckRender/PitchDeckRenderContainer'))

export const PITCH_DECK_RENDER_PATH = '/render/pitch-deck'

// Data-less targets for headless renderers. `App` serves these outside
// `Providers`, so they never wait on auth or load analytics.
export const renderRoutes = [
  <Route
    key='render-pitch-deck'
    path={PITCH_DECK_RENDER_PATH}
    element={
      <Suspense fallback={null}>
        <PitchDeckRenderContainer />
      </Suspense>
    }
  />
]
